import { useState } from 'react';
import { defaultPeriod, PeriodRange } from './overview/PeriodPicker';

/** Props shared by every profile tab that has a date filter (all but Personal info). */
export interface ProfileDateRangeProps {
  /** Shared date range, owned by the profile so it is the same across tabs. */
  dateRange: PeriodRange;
  /** Updates the shared date range. */
  onDateRangeChange: (range: PeriodRange) => void;
}

/**
 * Single source of truth for the profile date range, shared across every tab that
 * has a date filter. Kept in state only, so it resets to the default on each page
 * refresh while staying consistent as the user moves between tabs.
 */
export const useProfileDateRange = (): [PeriodRange, (range: PeriodRange) => void] => {
  const [range, setRange] = useState<PeriodRange>(defaultPeriod);

  return [range, setRange];
};

export default useProfileDateRange;
